import _ from 'lodash'
import { Structure } from '../types'
import type { PageJson } from '@wix/thunderbolt-becky-types'

type StructureAndData = { data: PageJson['data']; structure: Structure }

const fixStructure = (flatStructure: StructureAndData['structure']): StructureAndData['structure'] => {
	// @ts-ignore
	return _.mapValues(flatStructure, (comp) => {
		return {
			...comp,
			layout: undefined,
		}
	})
}

const oneDocFixerForPage = (structureAndData: StructureAndData): StructureAndData => {
	const { data, structure } = structureAndData

	const fixedFlatStructure = fixStructure(structure)

	return {
		structure: fixedFlatStructure,
		data,
	}
}

export default oneDocFixerForPage
